import { render, staticRenderFns } from "./KnFormIncome.vue?vue&type=template&id=35710516"
import script from "./KnFormIncome.js?vue&type=script&lang=js&external"
export * from "./KnFormIncome.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports